export const PROGRAMDEF = null;